export default "__VITE_PUBLIC_ASSET__73e334d3__"